import { render, staticRenderFns } from "./QuantitativosFotosModal.vue?vue&type=template&id=d13ff83a&scoped=true"
import script from "./QuantitativosFotosModal.vue?vue&type=script&lang=js"
export * from "./QuantitativosFotosModal.vue?vue&type=script&lang=js"
import style0 from "./QuantitativosFotosModal.vue?vue&type=style&index=0&id=d13ff83a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d13ff83a",
  null
  
)

export default component.exports